import BaseAPI from './base'

class StudentPackageAPI extends BaseAPI {}

export default new StudentPackageAPI('v1/student-packages', 'StudentPackage')
